export const _450px = "450px"
// `sm` applies to x-small devices (portrait phones, less than 576px)
export const _576px = "576px";
// `md` applies to small devices (landscape phones, less than 768px)
export const _768px = "768px";
// `lg` applies to medium devices (tablets, less than 992px)
export const _992px = "992px";
// `lg` applies to medium devices (tablets, less than 992px)
export const _991px = "991px";
// `xl` applies to large devices (desktops, less than 1200px)
export const _1200px = "1200px";
// `xxl` applies to x-large devices (large desktops, less than 1400px)
export const _1400px = "1400px";
// `xxl` applies to x-large devices (large desktops, less than 1500px)
export const _1500px = "1500px";
// `xxxl` applies to xx-large devices (large desktops, less than 1600px)
export const _1600px = "1600px";
// `xxxxl` applies to xxx-large devices (large desktops, less than 1700px)
export const _1700px = "1700px";
// `xxxxxl` applies to xxxx-large devices (large desktops, less than 1800px)
export const _1800px = "1800px";
// `xxxxxl` applies to xxxx-large devices (large desktops, less than 2200px)
export const _2200px = "2200px";